import { render } from "./createDetail.vue?vue&type=template&id=2d1ebece&scoped=true"
import script from "./createDetail.vue?vue&type=script&lang=ts"
export * from "./createDetail.vue?vue&type=script&lang=ts"

import "./createDetail.vue?vue&type=style&index=0&id=2d1ebece&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d1ebece"

export default script